module.exports = __webpack_public_path__ + "img/yangliZkxl.8aa01c81.png";